import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import { find, get, map, isEmpty, filter } from 'lodash';
import { updateAddOnsIndex } from '../../../../actions/add-ons';
import { createOfferQuote, hostUpdateQuote } from '../../../../actions/contracts';
import AddItemsForm from './AddItemsForm';
import { ADD_ITEMS_FORM } from '../../constants/formNames';

class AddItemsFormContainer extends Component {
  constructor (props) {
    super(props);

    this.viewAddOnDetailsAction = this.viewAddOnDetailsAction.bind(this);
    this.editAddOnAction = this.editAddOnAction.bind(this);
    this.handleItemChange = this.handleItemChange.bind(this);
  }

  componentDidMount () {
    const { dispatch, auth, payload, isHostUpdate } = this.props;
    const accessToken = get(auth, 'accessToken');

    if (isHostUpdate) {
      const bookingId = get(payload, 'data.control_id');
      return dispatch(hostUpdateQuote(payload.data, bookingId, accessToken));
    }

    dispatch(createOfferQuote(payload.data));
  }

  viewAddOnDetailsAction (itemId) {
    const { scrollToTop, toggleModal, iosWebView } = this.props;

    toggleModal(`viewAddOnDetailsModal-${itemId}`);

    if (iosWebView) {
      scrollToTop();
    }
  }

  editAddOnAction (index) {
    const { dispatch, toggleModal, iosWebView, scrollToTop } = this.props;

    dispatch(updateAddOnsIndex(index));

    toggleModal('editAddOnModal');

    if (iosWebView) {
      scrollToTop();
    }
  }

  handleItemChange (itemId, index) {
    const { dispatch, inventoryItems } = this.props;
    const item = find(inventoryItems, { _id: itemId });

    if (item) {
      const formItem = {
        ...item,
        title: item._id,
        count: null,
        unit_cost: (item.unit_cost).toFixed(2)
      };

      dispatch(change(ADD_ITEMS_FORM, `addOns[${index}]`, formItem));
    }
  }

  render () {
    return (
      <AddItemsForm
        {...this.props}
        getInventoryItem={this.props.getInventoryItem}
        viewAddOnDetailsAction={this.viewAddOnDetailsAction}
        editAddOnAction={this.editAddOnAction}
        handleItemChange={this.handleItemChange}
      />
    );
  }
}

AddItemsFormContainer.propTypes = {
  toggleModal: PropTypes.func,
  payload: PropTypes.object,
  iosWebView: PropTypes.bool,
  scrollToTop: PropTypes.func,
  isHostUpdate: PropTypes.bool
};

const selector = formValueSelector(ADD_ITEMS_FORM);

export function mapStateToProps (state) {
  const { auth, profile, add_ons, payload, contract } = state;
  // need to grab pendingContracts only for host custom offer
  // (before a booking req has been accepted)
  const contracts = get(contract, 'data.contracts', []);
  const pendingContracts = get(contract, 'data.pending', []);
  const currentContract = isEmpty(contracts) ? pendingContracts : contracts;

  const currentContractItems = filter(currentContract, { type: 'ITEM' });
  const inventoryItems = get(state, 'inventory.data.inventory');
  const items = selector(state, 'addOns');
  const payloadItems = get(payload, 'data.items');
  const bookingAddOns = filter(payloadItems, { type: 'ITEM' });

  const returnData = {
    auth,
    ssoId: profile.SSOid,
    add_ons,
    payload,
    inventoryItems,
    items,
    contract
  };

  if (!isEmpty(bookingAddOns)) {
    const addOns = map(bookingAddOns, addOn => {
      const itemData = find(currentContractItems, { item_id: addOn.info.item_id });

      // do not include deleted items
      const deletedItem = get(addOn, 'info.delete', false);
      if (isEmpty(itemData) || deletedItem) { return; }

      return {
        title: addOn.info.item_id,
        label: itemData.meta.label,
        count: Number(addOn.info.count) || null,
        unit_cost: Number(addOn.info.custom_price).toFixed(2),
        item_id: addOn.info.item_id,
        _id: addOn.info.item_id,
        is_concierge: itemData.meta.is_concierge
      };
    });

    return {
      ...returnData,
      initialValues: {
        addOns: filter(addOns, (addOn) => !!addOn) // filter out undefined values if items deleted
      }
    };
  }

  return {
    ...returnData,
    initialValues: {}
  };
}


export default connect(mapStateToProps)(AddItemsFormContainer);
